import React from "react";

const ArrowDownIcon = ({ width, height, color }) => {
  return (
    <svg
      width="13"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.29 14.29L9 16.59V5C9 4.73478 8.89464 4.48043 8.70711 4.29289C8.51957 4.10536 8.26522 4 8 4C7.73478 4 7.48043 4.10536 7.29289 4.29289C7.10536 4.48043 7 4.73478 7 5V16.59L4.71 14.29C4.5217 14.1017 4.2663 13.9959 4 13.9959C3.7337 13.9959 3.4783 14.1017 3.29 14.29C3.1017 14.4783 2.99591 14.7337 2.99591 15C2.99591 15.2663 3.1017 15.5217 3.29 15.71L7.29 19.71C7.3851 19.801 7.49725 19.8724 7.62 19.92C7.7397 19.9729 7.86913 20.0002 8 20.0002C8.13087 20.0002 8.2603 19.9729 8.38 19.92C8.50275 19.8724 8.6149 19.801 8.71 19.71L12.71 15.71C12.8983 15.5217 13.0041 15.2663 13.0041 15C13.0041 14.7337 12.8983 14.4783 12.71 14.29C12.6168 14.1968 12.5061 14.1228 12.3842 14.0723C12.2624 14.0219 12.1319 13.9959 12 13.9959C11.7337 13.9959 11.4783 14.1017 11.29 14.29ZM15 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2H15C15.2652 2 15.5196 1.89464 15.7071 1.70711C15.8946 1.51957 16 1.26522 16 1C16 0.734784 15.8946 0.48043 15.7071 0.292893C15.5196 0.105357 15.2652 0 15 0Z"
        fill="black"
      />
    </svg>
  );
};

export default ArrowDownIcon;
